const createState = () => ({
  loading: false,
  messages: [],
  toolMessage: '',
});

export default createState;
